<svg *ngIf="hasRange"
     class="range-bar"
     [attr.viewBox]="'0 0 ' + width + ' ' + height"
     [attr.width]="width"
     [attr.height]="height"
     [appTooltip]="rangeTooltip"
     aria-hidden="true">

  <!-- Track de fondo (rango completo) -->
  <rect class="range-track"
        [attr.x]="padding"
        y="3"
        [attr.width]="width - padding * 2"
        height="4"
        rx="2" ry="2"></rect>

  <!-- Borde sutil del rango -->
  <line class="range-edge"
        [attr.x1]="padding" y1="2"
        [attr.x2]="padding" y2="8"></line>
  <line class="range-edge"
        [attr.x1]="width - padding" y1="2"
        [attr.x2]="width - padding" y2="8"></line>

  <!-- Marker P50 -->
  <circle class="range-marker"
          [attr.cx]="markerX"
          cy="5"
          r="2.5"></circle>
</svg>
